import moment from 'moment'
import { RewardT } from '@/common/types'

export const isRewardActive = (reward: RewardT): boolean => {
    if (!reward.expiresAt) return true
    return moment().isBefore(moment(reward.expiresAt))
}

export const getNextExpiryDelayMs = (rewards: RewardT[]): number | null => {
    const now = moment()
    const upcomingDelaysMs = rewards
        .filter((reward) => reward.expiresAt)
        .map((reward) => moment(reward.expiresAt).diff(now))
        .filter((delayMs) => delayMs > 0)

    return upcomingDelaysMs.length > 0 ? Math.min(...upcomingDelaysMs) : null
}
